import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { TruncatedTypography } from 'src/components/TruncatedTypography';
import { formatAnnotationValue } from './utils';
import { useStyles } from './useStyles';

export const AnnotationPlainValue = ({ className, entries }) => {
  const styles = useStyles();

  const plainValue = useMemo(() => formatAnnotationValue(entries), [entries]);

  return (
    <TruncatedTypography className={cx(styles.root, className)}>{plainValue}</TruncatedTypography>
  );
};

AnnotationPlainValue.propTypes = {
  className: PropTypes.string,
  entries: PropTypes.arrayOf(PropTypes.oneOf([PropTypes.string, PropTypes.shape()]).isRequired),
};

AnnotationPlainValue.defaultProps = {
  className: null,
  entries: null,
};
